module.exports = __webpack_public_path__ + "static/img/mexc_icon.91de84b9.png";